import { MerchantProfitPage } from './merchant-profit';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    MerchantProfitPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantProfitPage),
    TranslateModule.forChild()
  ],
})
export class MerchantProfitPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-profit/merchant-profit.module.ts